<ng-container *ngIf="scrollY">
  <div #tableHeaderElement [ngStyle]="headerStyleMap" class="ant-table-header nz-table-hide-scrollbar">
    <table ui-table-content tableLayout="fixed" [scrollX]="scrollX" [listOfColWidth]="listOfColWidth" [theadTemplate]="theadTemplate"></table>
  </div>
  <div #tableBodyElement *ngIf="!virtualTemplate" class="ant-table-body" [ngStyle]="bodyStyleMap">
    <table ui-table-content tableLayout="fixed" [scrollX]="scrollX" [listOfColWidth]="listOfColWidth" [contentTemplate]="contentTemplate"></table>
  </div>
  <cdk-virtual-scroll-viewport
    #tableBodyElement
    *ngIf="virtualTemplate"
    [itemSize]="virtualItemSize"
    [maxBufferPx]="virtualMaxBufferPx"
    [minBufferPx]="virtualMinBufferPx"
    [style.height]="data.length ? scrollY : noDateVirtualHeight">
    <table ui-table-content tableLayout="fixed" [scrollX]="scrollX" [listOfColWidth]="listOfColWidth">
      <tbody>
        <ng-container *cdkVirtualFor="let item of data; let i = index; trackBy: virtualForTrackBy">
          <ng-template [ngTemplateOutlet]="virtualTemplate" [ngTemplateOutletContext]="{ $implicit: item, index: i }"></ng-template>
        </ng-container>
      </tbody>
    </table>
  </cdk-virtual-scroll-viewport>
</ng-container>
<div class="ant-table-content" #tableBodyElement *ngIf="!scrollY" [ngStyle]="bodyStyleMap">
  <table ui-table-content tableLayout="fixed" [scrollX]="scrollX" [listOfColWidth]="listOfColWidth" [theadTemplate]="theadTemplate" [contentTemplate]="contentTemplate"></table>
</div>
